<template>
  <section>
    <!-- Header -->
    <div class="header-bar header-fixed header-app header-bar-detached">
      <a data-bs-toggle="offcanvas" data-bs-target="#menu-main" href="#"
        ><i class="bi bi-list font-menu"></i
      ></a>
      <!-- <a href="#" class="header-title color-theme">SAMU IT4D</a> -->
      <div class="logo-container">
        <img src="../../assets/images/logo_rio.png" alt="logo" class="logo" />
      </div>

      <!-- <a href="#" data-bs-toggle="offcanvas" data-bs-target="#menu-color"
        ><i class="bi bi-palette-fill font-13 color-highlight"></i
      ></a> -->
      <!-- <a href="#" data-bs-toggle="offcanvas" data-bs-target="#menu-bell"
        ><em class="badge bg-highlight ms-1">3</em
        ><i class="font-14 bi bi-bell-fill"></i
      ></a> -->
      <!-- <a href="#" class="show-on-theme-light" @click="selectDarkMode"
        ><i class="bi bi-moon-fill font-13"></i
      ></a>
      <a href="#" class="show-on-theme-dark" @click="selectLightMode"
        ><i class="bi bi-lightbulb-fill color-yellow-dark font-13"></i
      ></a> -->
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      authenticated: false
    };
  },
  props: ["menu"],
  computed: {},
  methods: {
    selectDarkMode() {
      $("body")
        .removeClass("theme-light")
        .addClass("theme-dark");
    },
    selectLightMode() {
      $("body")
        .removeClass("theme-dark")
        .addClass("theme-light");
    },
    logout: function() {
      let self = this;
      let api = this.$store.state.api + "logout";

      self.$http
        .post(api)
        .then(response => {
          localStorage.removeItem("token");

          const redirectUri = encodeURIComponent(
            window.location.origin + "/login"
          );
          window.location.href =
            "https://sso.acesso.gov.br/logout?post_logout_redirect_uri=https://api.app-samu.ares-saude.com.br/api/v1/logout";
        })
        .catch(error => {
          this.errors = error.response.data.errors;
          this.$message("Erro", "Erro ao realizar logout", "error");
        });
    }
  },
  mounted() {
    this.authenticated = this.$store.getters.authenticated;
    this.user = this.$store.getters.user;
  }
};
</script>

<style scoped>
.header-bar {
  display: flex;
  align-items: center;
  background-color: #d6582c !important;
}

.logo-container {
  text-align: center;
  height: 78px;
  background-color: #d6582c !important;
  width: 80%;
}

.logo {
  margin-top: 0.8rem !important;
  margin-bottom: 6px !important;
  height: 52px;
  width: auto;
  max-width: 260px;
}
.font-menu {
  font-size: 32px !important;
  margin-left: 15px;
  color: #ffffff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/HeaderNavbar.vue